import React from 'react';
import { alert } from 'components/Alert';

export default (message, type = 'error', confirmButtonText) => {
  const content = React.isValidElement(message) ? (
    message
  ) : (
    <span dangerouslySetInnerHTML={{ __html: message }} />
  );

  alert.open({
    config: {
      type,
      title: type === 'error' ? 'Coś się pokićkało' : 'Sukces',
      description: content,
      confirmButtonText: confirmButtonText || (type === 'error' ? 'Innym razem' : 'Dzięki wielkie'),
    },
  });
};
